import classNames from "classnames/dedupe";
import PropTypes from "prop-types";
import React, { useState } from "react";
export const Checkbox = /*#__PURE__*/React.forwardRef(
/**
 * Checkbox component
 * @param {Object} props
 * @param {string} [props.id]
 * @param {string} props.name
 * @param {string} [props.size]
 * @param {((props: { disabled: boolean, isChecked: boolean, size: string }) => object) | string | { [key: string]: any }} [props.className]
 * @param {any} [props.value]
 * @param {boolean} [props.defaultChecked]
 * @param {boolean} [props.checked]
 * @param {boolean} [props.disabled]
 * @param {string} [props.title]
 * @param {boolean} [props.required]
 * @param {boolean} [props.valid]
 * @param {(checked: boolean) => ({}|void)} [props.onChange]
 * @param {boolean} [props.noSpanClick]
 * @param {*} ref
 * @returns {JSX.Element}
 */
function Checkbox({
  id,
  name,
  size = "regular",
  className,
  value = "",
  defaultChecked,
  checked,
  disabled = false,
  title,
  required,
  onChange,
  noSpanClick
}, ref) {
  const [_checked, setChecked] = useState(checked || defaultChecked); // override with checked when available

  const isChecked = typeof checked !== "undefined" ? checked : _checked;
  const checkboxClasses = classNames("border-2 checkbox inline-block cursor-pointer text-center font-bold", {
    disabled,
    checked: isChecked,
    "border-en-gray-400": disabled && !isChecked,
    "bg-en-gray-400 text-white": disabled && isChecked,
    "bg-en-yellow-700 text-white border-en-yellow-500": !disabled && isChecked,
    "border-en-gray-600 hover:bg-en-gray-400 hover:border-en-gray-100 hover:shadow-md": !disabled && !isChecked,
    "checkbox-small rounded": size === "small",
    "rounded-md": size === "regular"
  }, typeof className === "function" ? className({
    disabled,
    isChecked,
    size
  }) : className);

  const onSpanClickHandler = e => {
    e.stopPropagation();

    if (!noSpanClick) {
      onChangeHandler();
    }
  };

  const onChangeHandler = () => {
    if (!disabled) {
      setChecked(!isChecked);

      if (typeof onChange === "function") {
        onChange(!isChecked);
      }
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: checkboxClasses,
    onClick: onSpanClickHandler
  }), /*#__PURE__*/React.createElement("input", {
    id: id,
    name: name,
    type: "checkbox",
    style: {
      display: "none"
    },
    required: required,
    value: value,
    checked: isChecked,
    title: title,
    disabled: disabled,
    "aria-label": title,
    "aria-required": required,
    onChange: onChangeHandler,
    ref: ref
  }));
});
Checkbox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.oneOf(["small", "regular"]),
  className: PropTypes.string,
  required: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  valid: PropTypes.bool,
  value: PropTypes.any,
  title: PropTypes.string,
  onChange: PropTypes.func,
  noSpanClick: PropTypes.bool
};